module.exports = __webpack_public_path__ + "img/qznn.d5172b41.jpg";